import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-banner-contact',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatExpansionModule,
  ],
  templateUrl: './banner-contact.component.html',
  styleUrls: ['./banner-contact.component.scss'],
})
export class BannerContactComponent {
  // Observable that emits true on handset (small) screen sizes
  isHandset$: Observable<boolean> = this.bp.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  // drive both layouts from this single array
  contactItems = [
    {
      icon: 'phone',
      label: 'Phone',
      display: '(02) 8382 6575',
    },
    {
      icon: 'email',
      label: 'Email',
      display: "reception506@svha.org.au",
      link: 'mailto:reception506@svha.org.au',
    },
    {
      icon: 'fax',
      label: 'Fax',
      display: '(02) 8382 6578',
    },
  ];

  constructor(private bp: BreakpointObserver) {}
}
